var l = Object.defineProperty;
var c = (t, h, e) => h in t ? l(t, h, { enumerable: !0, configurable: !0, writable: !0, value: e }) : t[h] = e;
var i = (t, h, e) => (c(t, typeof h != "symbol" ? h + "" : h, e), e);
import { Material as m, Object3D as p } from "three";
import { getEuler as u } from "../../geometry-utils/three/index7.js";
import { RgMesh as f } from "./index3.js";
import { setColor as M } from "../create-geometry/index5.js";
const g = new m(), A = (t) => [t.color, t.alpha];
class d extends p {
  constructor(e, s = g) {
    super();
    i(this, "userData");
    i(this, "mesh");
    i(this, "isRgView", !0);
    i(this, "children", []);
    i(this, "rgChildren", []);
    i(this, "activeMeshes", 0);
    i(this, "meshAdded", !1);
    i(this, "material");
    i(this, "alpha");
    this.material = s, this.name = e.name, this.userData = e, this.position.fromArray(e.pos), this.alpha = e.alpha, u(e, this.rotation), this.mesh = new f(e, s, this), this.addMesh();
    for (const a of e.children)
      this.addRgObject(a);
  }
  clone() {
    return new d(this.userData, this.material);
  }
  addRgObject(e) {
    const s = new d(e, this.material);
    this.rgChildren.push(s), this.add(s), this.addActiveMeshes(s.activeMeshes);
  }
  addMesh() {
    this.meshAdded || !this.userData.alpha || (this.add(this.mesh), this.addActiveMeshes(1), this.meshAdded = !0);
  }
  removeMesh() {
    !this.meshAdded || (this.remove(this.mesh), this.addActiveMeshes(-1), this.meshAdded = !1);
  }
  addActiveMeshes(e) {
    if (this.activeMeshes += e, !this.parent || !("isRgView" in this.parent))
      return;
    this.parent.addActiveMeshes(e);
  }
  updateGeo() {
    this.mesh.updateGeo();
  }
  updateColour(e = A) {
    var o;
    const s = (o = this.parent) != null && o.isRgView ? this.parent.userData : void 0, [a, r] = e(this.userData, s);
    this.alpha = r, M(this.mesh.geometry, a, r);
    for (const n of this.rgChildren)
      n.updateColour(e);
  }
  setVisibility({ visibility: e, visible: s }) {
    let a = !0;
    this.userData.alpha && e.includes(this.userData.type) ? s && !s(this) && (a = !1) : a = !1, a ? this.addMesh() : this.removeMesh();
    for (const r of this.rgChildren)
      r.setVisibility({ visibility: e, visible: s });
  }
}
const V = (t) => !!t.isRgView;
export {
  d as RgView,
  V as isRgView
};
//# sourceMappingURL=index4.js.map
